import update from 'immutability-helper';

import useCheckoutState from './useCheckoutState';

export default function useCheckoutOrderBumpFormHelpers() {
  const { setForm, hasFocusedCheckoutRef } = useCheckoutState();

  function setOrderBump(productId, quantity) {
    hasFocusedCheckoutRef.current = true;

    setForm(form =>
      update(form, {
        orderBumps: {
          // $apply over $merge: survives a form state minted before
          // `orderBumps` existed (older draft flows spread prevForm).
          $apply: orderBumps => ({ ...(orderBumps || {}), [String(productId)]: quantity }),
        },
      }),
    );
  }

  /**
   * Drop a bump's answer entirely, rather than recording a 0.
   *
   * The difference matters: a 0 means "the buyer said no" and is what stops
   * preselect springing back over their untick, so a system-driven cleanup must
   * not write one. Pruning a bump that stopped being eligible (its rule no
   * longer matches, the price switched, it sold out) has to leave NO answer on
   * record, or a bump that becomes eligible again can never be preselected —
   * which is what left the editor preview stuck unticked after a save.
   */
  function clearOrderBump(productId) {
    hasFocusedCheckoutRef.current = true;

    setForm(form =>
      update(form, {
        orderBumps: {
          $apply: orderBumps => {
            const next = { ...(orderBumps || {}) };
            delete next[String(productId)];
            return next;
          },
        },
      }),
    );
  }

  // The figure as typed, in major units, as tickets and variants hold theirs:
  // getOrderBumpValues converts it to minor units.
  function setOrderBumpAmount(productId, amount) {
    hasFocusedCheckoutRef.current = true;

    setForm(form =>
      update(form, {
        orderBumpAmounts: {
          $apply: amounts => ({ ...(amounts || {}), [String(productId)]: amount }),
        },
      }),
    );
  }

  return { setOrderBump, clearOrderBump, setOrderBumpAmount };
}
